"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useActor_1 = require("./useActor");
function fromService(service) {
    var machine = service.machine;
    return {
        send: service.send.bind(service),
        subscribe: service.subscribe.bind(service),
        stop: service.stop,
        current: service.initialized ? service.state : machine.initialState,
        name: service.sessionId
    };
}
exports.fromService = fromService;
function useService(service) {
    var serviceActor = react_1.useMemo(function () { return fromService(service); }, [service]);
    return useActor_1.useActor(serviceActor);
}
exports.useService = useService;
